import axios, { AxiosResponse } from 'axios';
import {
  AuthUser,
  TAuthSignInReq,
  TAuthSignUpReq,
  TUserResetPasswordReq,
} from '@src/types';

export const getMe = (): Promise<AxiosResponse<AuthUser>> => {
  return axios.get('/auth/me');
};

export const getAdminMe = (): Promise<AxiosResponse<AuthUser>> => {
  return axios.get('/admin/auth/me');
};

export const requestResetPassword = (
  email: string
): Promise<AxiosResponse<string>> => {
  return axios.post('/auth/request-reset-password', {
    email: email.toLowerCase(),
  });
};

export const resetPassword = (
  data: TUserResetPasswordReq
): Promise<AxiosResponse<string>> => {
  return axios.post('/auth/reset-password/complete', data);
};

export const signIn = (data: TAuthSignInReq) => {
  return axios.post('/auth/signin', data);
};

export const signOut = (): Promise<AxiosResponse<{ message: string }>> => {
  return axios.post('/auth/logout');
};

export const signOutAdmin = (): Promise<AxiosResponse<{ message: string }>> => {
  return axios.post('/admin/auth/logout');
};

export const signUp = (data: TAuthSignUpReq) => {
  return axios.post('/auth/signup', data);
};

export const adminSignIn = (data: TAuthSignInReq) => {
  return axios.post('/admin/auth/signin', data);
};
